<template>
  <div class="home-header">
    <div class="subtitle">
      <p class="keywords">{{ appConfig.commonKeywords }}</p>
      <p class="description">{{ appConfig.commonDescription }}</p>
    </div>
    <div class="current-role" @click="toggleRole">
      <span>{{ getCompanyName(currentRole.companyId) }}</span>
      <span>{{ getTeamName(currentRole.teamId) }}</span>
      <span>{{ getRoleName(currentRole.roleId) }}</span>
      <CaretDownOutlined />
    </div>
    <p class="head-ctrl" v-if="userInfo">{{ userInfo.username }}</p>
    <p class="head-ctrl" @click="handleLogout">退出</p>
  </div>
</template>
<script>
import { CaretDownOutlined } from '@ant-design/icons-vue'
import { mapState } from 'vuex'
import { getCompanyName, getTeamName, getRoleName } from '@/filters'
export default {
  components: {
    CaretDownOutlined
  },
  computed: {
    ...mapState(['userInfo', 'appConfig', 'rolesVisible', 'currentRole']),
    breadcrumb () {
      return this.$route.meta.breadcrumb || []
    }
  },
  methods: {
    getCompanyName,
    getTeamName,
    getRoleName,
    handleLogout () {
      this.$store.commit('handleLogout')
    },
    toggleRole () {
      this.$store.commit('setRolesVisible', true)
    }
  }
}
</script>
<style lang="less">
.home-header {
  @topHeight: 60px;
  padding: 0 20px; height: @topHeight;
  display: flex; justify-content: flex-end; align-items: center;
  background: @theme; color: #fff;
  .subtitle {
    margin-right: auto;
    .keywords {
      font-size: 16px;
    }
    .description {
      font-size: 12px;
    }
  }
  .current-role {
    margin-right: 50px;
    span {
      margin-left: 20px;
    }
  }
  .head-ctrl {
    margin-right: 20px;
    cursor: pointer;
  }
}
</style>
